module.exports = __webpack_public_path__ + "012b3b9b910b20d90f08e9fb48633396.jpg";